/**
 * HTTP utility functions
 */
import axios from 'axios';
import { message } from 'antd';

/**
 * Common GET request
 * @param url       API endpoint
 * @param msg       Error message when request fails
 * @param headers   Required header configuration
 */


export const get = ({ url, msg , config }) =>{
    return  axios
    .get(url, config)
    .then(res => res.data)
    .catch(err => {
        console.log(err);
        message.warn(msg);
    });
}
   

/**
 * Common POST request
 * @param url       API endpoint
 * @param data      Request payload
 * @param msg       Error message when request fails
 * @param headers   Required header configuration
 */
export const post = ({ url, data, msg , config }) =>
    axios
        .post(url, data, config)
        .then(res => res.data)
        .catch(err => {
            console.log(err);
            message.warn(msg);
        });
